"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationBulkStatementSettingPatientTag_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PatientTagType_1 = require("./PatientTagType");
var LocationBulkStatementSettingPatientTag_Factory = /** @class */ (function () {
    function LocationBulkStatementSettingPatientTag_Factory() {
    }
    LocationBulkStatementSettingPatientTag_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            LocationBulkStatementSettingId: model.LocationBulkStatementSettingId,
            PatientTagType: PatientTagType_1.PatientTagType_Factory.CreateIncoming(model.PatientTagType),
            PatientTagTypeId: model.PatientTagTypeId,
            RecordId: model.RecordId,
        };
        return result;
    };
    LocationBulkStatementSettingPatientTag_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            LocationBulkStatementSettingId: model.LocationBulkStatementSettingId,
            PatientTagType: PatientTagType_1.PatientTagType_Factory.CreateOutgoing(model.PatientTagType),
            PatientTagTypeId: model.PatientTagTypeId,
            RecordId: model.RecordId,
        };
        return result;
    };
    return LocationBulkStatementSettingPatientTag_Factory;
}());
exports.LocationBulkStatementSettingPatientTag_Factory = LocationBulkStatementSettingPatientTag_Factory;
